"use strict";
/* create by Micheal Xiao 2019/7/23 11:26 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _0_jpg_1 = __importDefault(require("./0.jpg"));
var _1_jpg_1 = __importDefault(require("./1.jpg"));
var imgs = [_0_jpg_1.default, _1_jpg_1.default];
// TODO import once
exports.default = imgs;
